import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Sirajuddin Shaik </span>
            from <span className="purple"> Guntur, India.</span>
            <br />
            I am a Computer Science Engineering student with a passion for
            automating things using computer science.
            <br />
            I love experimenting and discovering new technologies and solutions.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing games
            </li>
            <li className="about-activity">
              <ImPointRight /> Experimenting with new things
            </li>
            <li className="about-activity">
              <ImPointRight /> Learning new and interesting tech
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Constantly push your boundaries to new heights, and relax at a time
            till the end!"{" "}
          </p>
          <footer className="blockquote-footer">😎</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
